import { render, staticRenderFns } from "./BNotification.vue?vue&type=template&id=21a20174"
import script from "./BNotification.vue?vue&type=script&lang=js"
export * from "./BNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports